var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',[_vm._t("default")],2),_vm._v(" "),_c('transition',{attrs:{"name":_vm.animation}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"my-dropdown-dd",style:(_vm.ddStyle)},[_vm._t("dropdown")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }